import { type TagColor } from '@/components/Tag/Tag'
import { USER_PROFILE } from '@/constants/user-profile'
import i18n from '@/i18n'

export const getColorByProfile = (value: string): TagColor => {
  switch (value) {
    case USER_PROFILE.TUTOR:
      return 'blue'
    case USER_PROFILE.TEACHER:
      return 'orange'
    case USER_PROFILE.SUPERUSER:
      return 'violet'
    case USER_PROFILE.PLANNER:
      return 'ultramarine'
    case USER_PROFILE.SUPPORT_STAFF:
    default:
      return 'gray'
  }
}

export const getLabelByProfile = (value: string): string => {
  switch (value) {
    case USER_PROFILE.TUTOR:
      return i18n.t('label.tutor', { ns: 'common' })
    case USER_PROFILE.TEACHER:
      return i18n.t('label.teacher', { ns: 'common' })
    case USER_PROFILE.SUPERUSER:
      return i18n.t('label.admin', { ns: 'common' })
    case USER_PROFILE.PLANNER:
      return i18n.t('label.planner', { ns: 'common' })
    case USER_PROFILE.SUPPORT_STAFF:
      return i18n.t('label.support-staff', { ns: 'common' })
    default:
      return value
  }
}
